<div class="modal-header">
    <h3 class="modal-title">{{ 'STARTNEWMODEL' | translate }}</h3>
</div>
<div class="modal-body">
    <div class="dl-template-picker-knoppen">
        <button class="btn btn-primary" (click)="nieuwModel()">
            {{ 'NEWMODEL' | translate }}
        </button>
        @if (picklist.templates.length) {
            <button class="btn btn-outline-primary dl-template-picker__tab"
                    [ngClass]="{ active: sublist === 'templates' }"
                    (click)="setSublist('templates')">
                {{ 'PICK_TEMPLATE' | translate }}
            </button>
        }
        @if (picklist.normmodels.length) {
            <button class="btn btn-outline-primary dl-template-picker__tab"
                    [ngClass]="{ active: sublist === 'normmodels' }"
                    (click)="setSublist('normmodels')">
                {{ 'PICK_NORMMODEL' | translate }}
            </button>
        }
    </div>
    @if (sublist !== '-') {
        <div class="list-group dl-template-picker-lijst">
            @for (template of picklist[sublist]; track template.id) {
                <button type="button"
                        class="list-group-item list-group-item-action"
                        [ngClass]="{ active: geselecteerd === template }"
                        (click)="klikTemplate(template, false)"
                        (dblclick)="klikTemplate(template, true)">
                    {{ template.titel }}
                </button>
            }
        </div>
    }
</div>
<div class="modal-footer">
    @if (geselecteerd) {
        <button class="btn btn-primary" (click)="laadTemplate()">
            {{ 'BTN_LOAD' | translate }}
        </button>
    }
    <button class="btn btn-secondary" (click)="annuleren()">
        {{ 'BTN_CANCEL' | translate }}
    </button>
</div>
